<template>
  <div class="s-header">
    <el-row style="position: relative">
      <div class="header-title">{{'AI体适能监测系统'}}</div>
      <!-- <div class="header-bk"></div> -->
      <s-personal></s-personal>
    </el-row>

  </div>
</template>

<script>
  import {baseUrl} from 'common/api/api'
  import SPersonal from 'components/personal/personal'
  export default {
    components: {
      SPersonal
    },
    data() {
      return {
        baseUrl:baseUrl,
        schoolName:''
      }
    },
    methods:{
      getSchoolData(){
        this.$http({
          method: 'get',
          url: this.baseUrl + '/api/system/org/school/byteachaer',
          params:{
            "parentId":''
          }
        }).then((res) => {
          if(res.body.data.length == 1){
            this.schoolName = res.body.data[0].name
          }else{
            this.schoolName = ""
          }
        })
      }
    },
    mounted() {
      this.getSchoolData()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .s-header{
    width:100%;
    height:50px;
    .header-title{
      // position: relative;
      z-index: 1000000;
      font-weight: 600;
      font-size: 16px;
      position: absolute;
      width: 200px;
      border-radius: 10px 10px 0 0;
      box-sizing: border-box;
      border-bottom: 3px solid #40a9ff;
      text-align: center;
      height: 50px;
      line-height: 50px;
      // background: brown;
      box-sizing: border-box;
    }
    .header-bk{
      // position: relative;
      z-index: 100000;
      font-weight: 600;
      font-size: 16px;
      position: absolute;
      width: 220px;
      bottom: 0;
      border-radius: 10px 10px 0 0;
      box-sizing: border-box;
      // border-bottom: 3px solid #40a9ff;
      text-align: center;
      height: 45px;
      line-height: 20px;
      background: brown;
      box-sizing: border-box;
    }
    .union-logo{
      img{
        width:36px;
        position:relative;
        top:12px;
        margin-right: 5px;
      }
    }
    .brandTitile{
      font-weight: bold;
      font-size:18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue